export default "__VITE_ASSET__6b90c776__"